/**
 * Sub-Admin Service
 */
import { getApiClient } from '../apiClient';
import { SUBADMIN_ENDPOINTS, replacePathParams } from '../endpoints';
import type {
  GetSubAdminsResponse,
  GetSubAdminsParams,
  GetSubAdminResponse,
  CreateSubAdminPayload,
  CreateSubAdminResponse,
  UpdateSubAdminPayload,
  UpdateSubAdminResponse,
  DeleteSubAdminResponse,
} from '../types/subAdmin.types';

export const subAdminService = {
  /**
   * Get all sub-admins with pagination and search
   */
  getSubAdmins: (params?: GetSubAdminsParams): Promise<GetSubAdminsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.page) {
      queryParams.append('page', String(params.page));
    }
    if (params?.limit) {
      queryParams.append('limit', String(params.limit));
    }
    if (params?.offset) {
      queryParams.append('offset', String(params.offset));
    }
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.permission) {
      queryParams.append('permission', params.permission);
    }
    const url = queryParams.toString()
      ? `${SUBADMIN_ENDPOINTS.getSubAdmins}?${queryParams.toString()}`
      : SUBADMIN_ENDPOINTS.getSubAdmins;
    return getApiClient().get(url);
  },

  /**
   * Get single sub-admin by ID
   */
  getSubAdmin: (id: string): Promise<GetSubAdminResponse> => {
    const url = replacePathParams(SUBADMIN_ENDPOINTS.getSubAdmin, { id });
    return getApiClient().get(url);
  },

  /**
   * Create sub-admin
   */
  createSubAdmin: (body: CreateSubAdminPayload): Promise<CreateSubAdminResponse> => {
    return getApiClient().post(SUBADMIN_ENDPOINTS.createSubAdmin, body);
  },

  /**
   * Update sub-admin
   */
  updateSubAdmin: (id: string, body: UpdateSubAdminPayload): Promise<UpdateSubAdminResponse> => {
    const url = replacePathParams(SUBADMIN_ENDPOINTS.updateSubAdmin, { id });
    return getApiClient().put(url, body);
  },

  /**
   * Delete sub-admin
   */
  deleteSubAdmin: (id: string): Promise<DeleteSubAdminResponse> => {
    const url = replacePathParams(SUBADMIN_ENDPOINTS.deleteSubAdmin, { id });
    return getApiClient().delete(url);
  },
};

